<template lang="html">
  <v-bottom-sheet v-model="show" persistent :content-class="'__popup-bottom rounded'">
    <v-sheet style="height: 100%">
      <v-form id="formNote" @submit.prevent="action(index, form)">
        <v-container fluid>
          <v-row>
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <div class="d-flex align-center">
                <h2 class="headline">
                  <span v-if="method == 'create'" class="font-weight-bold d-flex align-center">
                    Tambahkan catatan
                  </span>
                  <span v-else-if="method == 'update'" class="font-weight-bold d-flex align-center">
                    Edit catatan
                  </span>
                </h2>
                <v-spacer />
                <v-btn icon width="40" height="40" class="mr-2" @click="closeShowDetail()">
                  <v-icon>
                    mdi-close
                  </v-icon>
                </v-btn>
                <!-- <v-btn class="mt-2" text color="red" x-small @click="closeShowDetail()">
                  close
                </v-btn> -->
              </div>
            </v-col>
          </v-row>
          <v-row v-if="method == 'create'">
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <v-textarea
                v-model="form.note"
                label="Contoh : Es nya sedikit"
                prepend-inner-icon="mdi-file-document-outline"
                rows="4"
                solo
              />
            </v-col>
          </v-row>
          <v-row v-if="method == 'update'">
            <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4">
              <v-textarea
                v-model="form.note"
                label="Contoh : Es nya sedikit"
                prepend-inner-icon="mdi-file-document-outline"
                rows="4"
                solo
              />
            </v-col>
          </v-row>
          <div class="sec_add__to__cart">
            <v-row class="ma-0">
              <v-col cols="12" sm="6" offset-sm="3" md="4" offset-md="4" class="pa-0">
                <div class="text-center">
                  <v-btn large color="primary" width="100%" type="submit" form="formNote">
                    Simpan
                  </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </v-container>
      </v-form>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  name: 'BottomPopup',
  props: {
    action: {
      required: true,
      type: Function
    },
    method: {
      required: true,
      type: String
    }
  },
  data() {
    return {
      show: null,
      index: 0,
      form: {}
    }
  },
  mounted() {
    this.$root.$on('ShowAddPopup', (dataMenu) => {
      this.show = dataMenu.AddShow
      this.index = dataMenu.idItem
      if (this.$store.state.selected_type === 'RESERVATION') {
        this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_RESERVATION')).item[this.index]
      } else if (this.$store.state.selected_type === 'OL-TAKE-AWAY') {
        this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_OL-TAKE-AWAY')).item[this.index]
      } else if (this.$store.state.selected_type === 'DELIVERY') {
        this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DELIVERY')).item[this.index]
      } else if (this.$store.state.selected_type === 'DINE-IN') {
        this.form = JSON.parse(localStorage.getItem(process.env.VUE_APP_COOKIE_KEY + '_data_cart_DINE-IN')).item[this.index]
      }
    })
    this.$root.$on('CloseAddPopup', (dataMenu) => {
      this.show = dataMenu
    })
  },
  methods: {
    closeShowDetail() {
      this.show = false
      this.$root.$emit('CloseAddPopup', this.show)
    }
  }
}
</script>
